/* eslint jsx-a11y/anchor-is-valid: "off" */

import PropTypes from 'prop-types'
import React, { useState, useContext } from 'react'
import { Dropdown, DropdownButton, OverlayTrigger, Tooltip } from 'react-bootstrap'
import gql from 'graphql-tag'
import { useLazyQuery } from '@apollo/react-hooks'
import { Link } from 'react-router-dom'
import routes from '../routes'
import { get } from 'lodash'
import DeleteFileModal from './DeleteFileModal'
import S3DownloadModal from './S3DownloadModal'
import PublishFileModal from './PublishFileModal'
import UnpublishFileModal from './UnpublishFileModal'
import MFActionsModal from './MFActionsModal'
import ScanFileModal from './ScanFileModal'
import ScrapeXmlModal from './ScrapeXmlModal'
import AgolServiceModal from './AgolServiceModal'
import GeoserverModal from './GeoserverModal'
import UserContext from '../contexts/UserContext'
import {shouldFileDisable} from '../utils/fileSizeFunctions'
import {isPublishedToAGOL} from '../utils/isPublishedToAGOL'
import {isCloudRasterOrShapefile} from '../utils/isCloudRasterOrShapefile'


const GET_DOWNLOAD_URL = gql`
  query GetDownloadUrl($itemId: ID!, $name: String, $id: ID) {
    file(itemId: $itemId, name: $name, id: $id) {
      downloadUri
    }
  }
`

export default function FileRowActionsMenu({ row, itemId, canWrite, resetFiles, rowIndex, distributionLinks }) {
  const {roles} = useContext(UserContext)
  const [ showPublish, setShowPublish ] = useState(false)
  const [ showUnpublish, setShowUnpublish ] = useState(false)
  const [ showDelete, setShowDelete ] = useState(false)
  const [ showS3DownloadModal, setShowS3DownloadModal ] = useState(false)
  const [ showScrape, setShowScrape ] = useState(false)
  const [ showAgol, setShowAgol ] = useState(false)
  const [ showGeoserver, setShowGeoserver ] = useState(false)
  const [ showScan, setShowScan ] = useState(false)
  const [ actionValue, setActionValue ] = useState('migrate')
  const [ modalShow, setModalShow ] = useState(false)
  const [ hasMigrate, setHasMigrate ] = useState(row.movedToS3)
  const [ isduplicatefile, setIsDuplicatefile ] = useState(false)

  const fetchVariables = (row) => {

    if (!row) return {}

    return {
      id: row.id,
      name: row.name,
      itemId: itemId
    }
  }

  // This doesn't run unless the create download link button is clicked
  const [ handleDownload, { called, loading, data } ] = useLazyQuery(
    GET_DOWNLOAD_URL,
    {
      variables: fetchVariables(row),
      fetchPolicy: 'no-cache'
    },
  )

  const downloadUri = get(data, 'file.downloadUri', null)
  if (downloadUri) {
    window.location.href = downloadUri
  }

  const resetValue = (value) => {
    setHasMigrate(value)
  }

  const canBePublished = (row) => {
    if (row.published) { // File already published
      return false
    } else if (!row.bucket){
      return false // File not in s3
    } else {
      return true // All other cases (file in s3 but not published)
    }
  }

  const isInPublishBucket = (row) => {
    // check to see if 'publish' found in theFile.bucket
    if (row.bucket) {
      return row.bucket.includes('publish')
    }
    return false
  }

  const isScanning = shouldFileDisable(row)
  const isPublishedAGOL = isPublishedToAGOL(distributionLinks)
  const isCloudGeoserver = isCloudRasterOrShapefile(row)
  const isFileInFacet = row.facetClass ? true : false
  const cantBePublished = !canBePublished(row)

  return (
    <DropdownButton style={{ position: 'static' }} title='' size="sm" drop="down" alignRight>
      <Dropdown.Item
        key={row.id + '_details'}
        as={Link}
        to={`${routes.itemPath}/${itemId}/file/${row.id || row.name}`}
      >
        Details
      </Dropdown.Item>
      <OverlayTrigger placement="left" overlay={isScanning ? <Tooltip id="button-tooltip">Disabled: File scanning</Tooltip> : <div></div>}>
        <div>
          <Dropdown.Item disabled={isScanning?true:false}
            key={row.id + '_download'}
            href="#"
            onClick={()=>handleDownload(row)}
          >
            Download
          </Dropdown.Item>
        </div>
      </OverlayTrigger>
      {row.published?(<Dropdown.Item href="#" disabled={isScanning ? true : false}
        onClick={() => {setShowUnpublish(true)}}>Unpublish</Dropdown.Item>)
        :(<OverlayTrigger placement="left" overlay={isScanning ? <Tooltip id="button-tooltip">Disabled: File scanning</Tooltip> : (cantBePublished ? <Tooltip id="button-tooltip">Disabled: File On-prem</Tooltip> : <div></div>)}>
          <div>
            <Dropdown.Item
              disabled={(!canWrite || isScanning || cantBePublished) ? true : false}
              key={row.id + '_publish'}
              href="#"
              onClick={() => {
                setActionValue('publish')

                if(isInPublishBucket(rowIndex)){
                  setIsDuplicatefile(true)
                }
                setShowPublish(true)
              }}>
              Publish
            </Dropdown.Item>
          </div>
        </OverlayTrigger>
        )}
      <UnpublishFileModal
        disabled={!canWrite}
        key={row.id + '_unpublish_modal'}
        show={showUnpublish}
        onHide={() => {
          setShowUnpublish(false)
        }}
        row={row}
        itemId={itemId}
      />
      <Dropdown.Item
        disabled={!canWrite}
        key={row.id + '_delete'} href="#"
        onClick={(e) => {
          e.preventDefault()
          setShowDelete(true)
        }}
      >
        Delete
      </Dropdown.Item>
      {row.name.endsWith('zap') && row.processStatus !== 'unzipped' && row.processStatus !== 'unzipping' && row.location==='s3'?(
        <>
          <Dropdown.Divider />
          <OverlayTrigger placement="left" overlay={isScanning ? <Tooltip id="button-tooltip">Disabled: File scanning</Tooltip> : <div></div>}>
            <div>
              <Dropdown.Item
                disabled={(!canWrite || isScanning) ? true : false}
                key={row.id + '_unzip'}
                href="#"
                onClick={() => {
                  setActionValue('Unzip')
                  setModalShow(true)
                }} >
                    Unzip
              </Dropdown.Item>
            </div>
          </OverlayTrigger>
        </>
      ): (
        ''
      )}
      {!isPublishedAGOL && row.name.endsWith('sd') && ((row.bucket==='dev-is-sb-beta-publish') || (row.bucket==='prod-is-usgs-sb-prod-publish' && (roles.includes('ScienceBase_SystemAdmin') || roles.includes('USGS'))))?(
        <>
          <Dropdown.Divider />
          <OverlayTrigger placement="left" overlay={isScanning ? <Tooltip id="button-tooltip">Disabled: File scanning</Tooltip> : <div></div>}>
            <div>
              <Dropdown.Item
                disabled={(!canWrite || isScanning) ? true : false}
                key={row.id + '_agol'}
                href="#"
                onClick={() => {
                  setActionValue('publish')
                  setShowAgol(true)
                }} >
                    Publish to ArcGIS Online
              </Dropdown.Item>
            </div>
          </OverlayTrigger>
        </>
      ): (
        ''
      )}
      {isPublishedAGOL && row.name.endsWith('sd') && ((row.bucket==='dev-is-sb-beta-publish') || (row.bucket==='prod-is-usgs-sb-prod-publish' && (roles.includes('ScienceBase_SystemAdmin') || roles.includes('USGS'))))?(
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            disabled={(!canWrite || isScanning) ? true : false}
            key={row.id + '_agol_unpublish'}
            href="#"
            onClick={() => {
              setActionValue('delete')
              setShowAgol(true)
            }} >
                Unpublish from ArcGIS Online
          </Dropdown.Item>
        </>
      ): (
        ''
      )}
      {row.location==='disk' && !hasMigrate?(
        <>
          <Dropdown.Divider />
          <OverlayTrigger placement="left" overlay={isFileInFacet ? <Tooltip id="button-tooltip">Disabled: File in facet</Tooltip> : <div></div>}>
            <div>
              <Dropdown.Item
                disabled={(!canWrite || isScanning || isFileInFacet) ? true : false}
                key={row.id + '_migrate'}
                href="#"
                onClick={() => {
                  setActionValue('Migrate')
                  setModalShow(true)
                }} >
                  Migrate
              </Dropdown.Item>
            </div>
          </OverlayTrigger>
        </>
      ): (
        ''
      )}

      {row.bucket==='dev-is-sb-beta-content' || row.bucket==='prod-is-usgs-sb-prod-content' && (roles.includes('ScienceBase_SystemAdmin') || roles.includes('USGS')) && row.location==='s3'?(
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            href="#"
            onClick={() => {
              setActionValue('scan')
              setShowScan(true)
            }}
          >
            ReScan File
          </Dropdown.Item>

        </>
      ) : (
        ''
      )}


      {canWrite && row.contentType == 'application/fgdc+xml' && (row.location === 's3') ? (
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            href="#"
            onClick={() => {
              setActionValue('fgdc')
              setShowScrape(true)
            }}
          >
            Scrape fgdc xml
          </Dropdown.Item>

        </>
      ) : (
        ''
      )}
      {/* {canWrite && row.contentType == 'application/md+json' && (row.location === 's3') && (process.env.REACT_APP_DEPLOYMENT_ENV !== "production")? ( */}
      {canWrite && row.contentType == 'application/md+json' && (row.location === 's3') ? (
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            href="#"
            onClick={() => {
              setActionValue('mdJson')
              setShowScrape(true)
            }}
          >
            Scrape md json
          </Dropdown.Item>

        </>
      ) : (
        ''
      )}
      {canWrite && row.name.endsWith('shp') && (row.location === 's3') && ((row.bucket==='dev-is-sb-beta-publish') || (row.bucket==='prod-is-usgs-sb-prod-publish')) && !isCloudGeoserver ? (
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            href="#"
            onClick={() => {
              setActionValue('createShapefile')
              setShowGeoserver(true)
            }}
          >
            Create Shapefile Service
          </Dropdown.Item>
        </>
      ) : (
        ''
      )}

      {canWrite && row.name.endsWith('.shp') && (row.location === 's3') && ((row.bucket==='dev-is-sb-beta-publish') || (row.bucket==='prod-is-usgs-sb-prod-publish')) && isCloudGeoserver ? (
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            href="#"
            onClick={() => {
              setActionValue('deleteShapefile')
              setShowGeoserver(true)
            }}
          >
            Delete Shapefile Service
          </Dropdown.Item>
        </>
      ) : (
        ''
      )}

      {canWrite && (row.name.endsWith('.tif') || row.name.endsWith('.tiff') || row.contentType === 'image/tiff' || row.contentType === 'image/geotiff') && (row.location === 's3')  && ((row.bucket==='dev-is-sb-beta-publish') || (row.bucket==='prod-is-usgs-sb-prod-publish')) && !isCloudGeoserver ? (
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            href="#"
            onClick={() => {
              setActionValue('createRaster')
              setShowGeoserver(true)
            }}
          >
            Create Raster Service
          </Dropdown.Item>
        </>
      ) : (
        ''
      )}

      {canWrite && (row.name.endsWith('.tif') || row.name.endsWith('.tiff') || row.contentType === 'image/tiff') && (row.location === 's3')  && ((row.bucket==='dev-is-sb-beta-publish') || (row.bucket==='prod-is-usgs-sb-prod-publish')) && isCloudGeoserver ? (
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            href="#"
            onClick={() => {
              setActionValue('deleteRaster')
              setShowGeoserver(true)
            }}
          >
            Delete Raster Service
          </Dropdown.Item>
        </>
      ) : (
        ''
      )}

      <PublishFileModal
        action = {actionValue}
        key={row.id + '_publish_modal'}
        show={showPublish}
        onHide={() => {
          setShowPublish(false)
        }}
        row={row}
        itemId={itemId}
        isduplicatefile={isduplicatefile}
      />
      <ScanFileModal
        action={actionValue}
        key={row.id + '_scan_modal'}
        show={showScan}
        onHide={() => {
          setShowScan(false)
        }}
        row={row}
        itemId={itemId}
      />
      <MFActionsModal
        action = {actionValue}
        key={row.id + '_migrate_modal'}
        show={modalShow}
        onHide={() => {
          setModalShow(false)
        }}
        row={row}
        itemId={itemId}
        resetRow = {resetValue}
        resetFiles = {resetFiles}
        rowIndex = {rowIndex}
      />
      <DeleteFileModal
        key={row.id + '_delete_modal'}
        show={showDelete}
        onHide={() => {
          setShowDelete(false)
        }}
        row={row}
        itemId={itemId}
      />
      <ScrapeXmlModal
        action={actionValue}
        key={row.id + '_scrape_xml_modal'}
        show={showScrape}
        onHide={() => {
          setShowScrape(false)
        }}
        row={row}
        itemId={itemId}
      ></ScrapeXmlModal>
      <AgolServiceModal
        action={actionValue}
        key={row.id + '_agol_service_modal'}
        show={showAgol}
        onHide={() => {
          setShowAgol(false)
        }}
        row={row}
        itemId={itemId}
      ></AgolServiceModal>
      <GeoserverModal
        action={actionValue}
        key={row.id + '_geoserver_modal'}
        show={showGeoserver}
        onHide={() => {
          setShowGeoserver(false)
        }}
        row={row}
        itemId={itemId}
      ></GeoserverModal>
      { row.published ? (
        <>
          <S3DownloadModal
            show={showS3DownloadModal}
            onHide={() => {
              setShowS3DownloadModal(false)
            }}
            row={row}
          ></S3DownloadModal>
        </>
      ) : (
        ''
      )}
    </DropdownButton>
  )
}

FileRowActionsMenu.propTypes = {
  resetFiles: PropTypes.func,
  rowIndex: PropTypes.number,
  client: PropTypes.shape({
    query: PropTypes.func
  }),
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    published: PropTypes.bool,
    name: PropTypes.string,
    id: PropTypes.string,
    movedToS3: PropTypes.bool,
    processStatus: PropTypes.string,
    contentType: PropTypes.string,
    location: PropTypes.string,
    scrapeMetadata: PropTypes.any,
    facetClass : PropTypes.string,
    facetName : PropTypes.string,
    status: PropTypes.shape({
      scanPassed: PropTypes.bool
    })
  }),
  itemId: PropTypes.string,
  fileConnection: PropTypes.shape({
    files: PropTypes.array,
    totalCount: PropTypes.number
  }),
  canWrite: PropTypes.bool,
  distributionLinks: PropTypes.array
}
